import { gql } from '@apollo/client';

import {
  UtRemoteVoiceCommandDocument,
  type UtRemoteVoiceCommandSubscription,
  type UtRemoteVoiceCommandSubscriptionVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    subscription UtRemoteVoiceCommand($uniqueId: ID!) {
      utRemoteVoiceCommand(uniqueId: $uniqueId) {
        transcript
        triggerWord
        type
        confidence
        timestamp
        isFinal
      }
    }
  `;
}

export const UT_REMOTE_VOICE_COMMAND = UtRemoteVoiceCommandDocument;
export type {
  UtRemoteVoiceCommandSubscription,
  UtRemoteVoiceCommandSubscriptionVariables,
};
